import { lazy, Suspense, useEffect } from "react";
import { getRoute } from "../shared/lib/routing";

const AdminPage = lazy(() => import("../features/admin/ui/AdminPage").then((module) => ({ default: module.AdminPage })));
const WeddingPage = lazy(() => import("../features/wedding/ui/WeddingPage").then((module) => ({ default: module.WeddingPage })));

export function App() {
  const route = getRoute(window.location.pathname);

  useEffect(() => {
    if (route.kind === "admin") {
      document.documentElement.lang = "it";
      document.title = "Admin RSVP - Peter & Francesca";
      document.body.classList.add("admin-page");
      return () => document.body.classList.remove("admin-page");
    }

    document.documentElement.lang = route.lang;
    document.title = "F&P 12/09/2026";
    document.body.classList.remove("admin-page");
  }, [route]);

  if (route.kind === "admin") {
    return (
      <Suspense fallback={null}>
        <AdminPage />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={null}>
      <WeddingPage lang={route.lang} />
    </Suspense>
  );
}
